import { userConstants } from "../../constant";
// import { product } from "./product";
const initialState = {
  orderItems: [],
  sellerOrderItem: [],
  removeData: false
};
export function checkout(state = { initialState }, action) {
  switch (action.type) {
    case userConstants.GET_ORDER_ITEMS:
      return {
        orderItems: action.payload,
        orderPagination: action.pagination || {},
      };

    default:
      return state;
  }
}

